import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setPortal } from 'modules/portal';
import { getDate, getHeadObj, makeRowColumn } from 'lib/commonLib';
import { requestStatistics } from 'lib/api/request';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import StatisticsGraph from './StatisticsGraph';

let initialization = false;
const Statistics = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));

  const sDate = moment().subtract(1, 'days');
  const eDate = moment().subtract(1, 'days');
  const initParam = {
    sDate: getDate(sDate),
    eDate: getDate(eDate),
  };
  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    MEDIA_SCRIPT_CNT: {
      makeHead: (headsMap) => {
        return {
          content: <>{getHeadObj(headsMap, 'MEDIA_SCRIPT_CNT').label}</>,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'MEDIA_SCRIPT_CNT');
        const showWindowUrl =
          '/report/daily/targeting?uri=/report/daily/targeting&mediaId=' +
          rowObj['MEDIA_ID'] +
          '&sDate=' +
          params.sDate +
          '&eDate=' +
          params.eDate +
          '&isPop=1';
        return (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['MEDIA_SCRIPT_CNT'],
              valObj.type,
              valObj.format
            )}
            icon={rowObj['SITE_NAME'] !== 'total' && 'faExternalLink'}
            toolTipTitle={t('해당 매체의 구좌별 타게팅분포')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
      },
    },

    TRGT_ADVRTS_AMT: {
      merged: true,
    },
    ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return {
          content: <>{getHeadObj(headsMap, 'ADVRTS_AMT').label} (쇼핑)</>,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const advrtsAmt = getHeadObj(headsMap, 'ADVRTS_AMT');
        const trgtAdvrtsAmt = getHeadObj(headsMap, 'TRGT_ADVRTS_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['ADVRTS_AMT'],
              advrtsAmt.type,
              advrtsAmt.format
            )}
            <span className={'black'}>
              (
              {makeRowColumn(
                rowObj['TRGT_ADVRTS_AMT'],
                trgtAdvrtsAmt.type,
                trgtAdvrtsAmt.format
              )}
              )
            </span>
          </>
        );
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          initData={initParam}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <StatisticsGraph params={{ ...params }} />
          <TableContainer
            dataReqPromise={requestStatistics}
            params={{ ...params }}
            sort="desc"
            order="ADVRTS_AMT"
            dense={true}
            customized={customized}
            hasExcel
            hasTotal={true}
          />
        </>
      )}
    </>
  );
};

export default Statistics;
